module.exports = __webpack_public_path__ + "img/cloud.355e5825.svg";